import {AfterViewInit, Component, ElementRef, ViewChild} from '@angular/core';
import {NgbModal, NgbModalRef} from "@ng-bootstrap/ng-bootstrap";
import {NgSignaturePadOptions, SignaturePadComponent} from "@almothafar/angular-signature-pad";
import {Router} from "@angular/router";
import {NbSubmitResponse, PremiData} from "../service/model/keterangan-kesehatan.model";
import {NasabahModel} from "../service/model/dashboard.model";
import {DraftService} from "../service/save-draft/save-draft.service";
import {LoginModel} from "../login/shared/login.model";

@Component({
  selector: 'app-summary',
  templateUrl: './summary.component.html',
  styleUrls: ['./summary.component.css']
})
export class SummaryComponent implements AfterViewInit {
  modalRef: NgbModalRef | undefined;

  @ViewChild('ttdCandidateContainer')
  ttdCandidateContainer!: ElementRef;

  @ViewChild('ttdSalesContainer')
  ttdSalesContainer!: ElementRef;

  @ViewChild('signatureCandidate')
  public signaturePadCandidate!: SignaturePadComponent;
  public signaturePadOptionsCandidate: NgSignaturePadOptions = {
    minWidth: 1,
    canvasHeight: 200,
    canvasWidth: 200,
    penColor: 'black',
    backgroundColor: 'white',
    dotSize: 1,
    maxWidth: 1,
    velocityFilterWeight: 1
  }

  @ViewChild('signatureBank')
  public signaturePadBank!: SignaturePadComponent;
  public signaturePadOptionsBank: NgSignaturePadOptions = {
    minWidth: 1,
    canvasHeight: 200,
    canvasWidth: 200,
    penColor: 'black',
    backgroundColor: 'white',
    dotSize: 1,
    maxWidth: 1,
    velocityFilterWeight: 1
  }

  isTtdCandidateChecked: boolean = false;
  isTtdStaffChecked: boolean = false;
  isTtdAgreementChecked: boolean = false;
  isMarketingChecked: boolean = false;


  ngAfterViewInit() {
    this.ttdCandidateContainer.nativeElement.style.width = '200px';
    this.ttdSalesContainer.nativeElement.style.width = '200px';
    this.signaturePadCandidate.set('canvasHeight', 200); // Set your preferred height
    this.signaturePadBank.set('canvasHeight', 200); // Set your preferred height
  }

  kontakKantor: any;
  dataPribadi: any = {};
  rincianPertanggungan: any = {};
  calculator: any = {};
  selectedProduct: any = {};
  kontakPribadi: any;
  newBusiness: NbSubmitResponse = {};
  premiData: PremiData = {}
  tandaTangan = {
    isPreview: false,
    ttdCandidate: "",
    ttdSales: "",
    tempatTandaTangan: ""
  }
  totalPremi: number = 0;

  isFromDashboard: boolean = false;
  nasabah: NasabahModel = {
    nasabahUw: {},
    nasabahNewCovering: {},
    nasabahCalculator: {}
  };

  draftCover3 : any;
  login: LoginModel = {}



  constructor(private modalService: NgbModal,
              private router: Router,
              private draftService: DraftService) {
    let jsonPertanggungan = localStorage.getItem('rincian-pertanggungan')
    let jsonPribadi = localStorage.getItem('data-pribadi')
    let jsonCalculator = localStorage.getItem('calculator')
    let jsonProduct = localStorage.getItem('selected-product')
    let jsonDummy = localStorage.getItem('new-covering-response')
    let jsonLogin = sessionStorage.getItem('login')

    if (jsonLogin) {
      this.login = JSON.parse(jsonLogin);
    }

    if (jsonDummy) {
      this.newBusiness = JSON.parse(jsonDummy)
      this.premiData = JSON.parse(this.newBusiness.premiData!)
      this.totalPremi = Number(this.premiData.standardPremi) + Number(this.premiData.extraPremium)
    }

    if (jsonPribadi) {
      this.dataPribadi = JSON.parse(jsonPribadi)
    }

    if (jsonPertanggungan && jsonCalculator && jsonProduct) {
      this.rincianPertanggungan = JSON.parse(jsonPertanggungan)
      this.calculator = JSON.parse(jsonCalculator)
      this.selectedProduct = JSON.parse(jsonProduct)
      this.calculator.totalPremium = Number(this.premiData.standardPremi) + Number(this.premiData.extraPremium ?? "0")
    }

    this.isFromDashboard = JSON.parse(localStorage.getItem("from-dashboard")!)
    if (this.isFromDashboard) {
      let dataDashboard = JSON.parse(localStorage.getItem("data-dashboard")!)
      let nb = JSON.parse(localStorage.getItem("new-business")!)
      this.nasabah = JSON.parse(localStorage.getItem("nasabah")!);
      this.selectedProduct.productname = this.nasabah.nasabahNewCovering.productName ?? "SMARTPROTECTION SMBCI Purnabakti"
      this.selectedProduct.productcode = this.nasabah.nasabahNewCovering.productCode ?? "SPKTAPBTPN"
      this.selectedProduct.referenceNumber = this.nasabah.nasabahNewCovering.referenceNo
      // this.rincianPertanggungan.dob = this.nasabah.nasabahNewCovering.dob ? this.nasabah.nasabahNewCovering.dob.split("T")[0] : dataDashboard.dob.split("T")[0]
      let dobNasabahNewCovering = new Date()
      if (this.nasabah.nasabahNewCovering.dob) {
        dobNasabahNewCovering = new Date(Date.parse(this.nasabah.nasabahNewCovering.dob))
        dobNasabahNewCovering.setHours(dobNasabahNewCovering.getHours() + 7)
      }

      this.rincianPertanggungan.dob = this.nasabah.nasabahNewCovering.dob ? dobNasabahNewCovering.toISOString().split("T")[0] : dataDashboard.dob.split("T")[0]
      this.rincianPertanggungan.uangPertanggungan = this.nasabah.nasabahNewCovering.sumAssured ?? dataDashboard.kontribusiDasar
      this.rincianPertanggungan.masaPertanggungan = this.nasabah.nasabahCalculator.tenure
    }

    this.draftService.getDraft({
      userId: this.login.userid,
      pageId: "draftCover3",
      partnerId: this.login.partnerId,
      productCode: this.selectedProduct.productcode,
      referenceNo: this.selectedProduct.referenceNumber
    }).subscribe(res => {
      this.draftCover3 = res
    })
  }


  clearCandidate() {
    this.tandaTangan.ttdCandidate = ""
    this.signaturePadCandidate.clear();
  }

  clearBank() {
    this.tandaTangan.ttdSales = "";
    this.signaturePadBank.clear();
  }

  drawCompleteCandidate() {
    this.tandaTangan.ttdCandidate = this.signaturePadCandidate.toDataURL();
  }

  drawCompleteSales() {
    this.tandaTangan.ttdSales = this.signaturePadBank.toDataURL();
  }


  togglePernyataanKuasa(content: any) {
    this.modalRef = this.modalService.open(content)
  }

  continue() {
    if (!this.isTtdStaffChecked || !this.isTtdCandidateChecked || !this.isTtdAgreementChecked) {
      alert("Mohon untuk menyetujui ketentuan dan mengisi kolom tanda tangan")
    } else if (!this.tandaTangan.ttdCandidate || !this.tandaTangan.ttdSales) {
      alert("Mohon untuk mengisi tanda tangan E-SPAJK")
    } else if (!this.tandaTangan.tempatTandaTangan) {
      alert("Mohon untuk mengisi tempat tanda tangan E-SPAJK")
    } else {

      this.draftService.saveDraft({
        userId: this.login.userid,
        pageId: "draftCover3",
        partnerId: this.login.partnerId,
        productCode: this.selectedProduct.productcode,
        referenceNo: this.selectedProduct.referenceNumber,
        companyName: this.draftCover3.companyName,
        officeAddress: this.draftCover3.officeAddress,
        officeZipCode: this.draftCover3.officeZipCode,
        officeProvince: this.draftCover3.officeProvince,
        officeCity: this.draftCover3.officeCity,
        ttdSales: this.tandaTangan.ttdSales,
        ttdCandidate: this.tandaTangan.ttdCandidate,
        ttdTempat: this.tandaTangan.tempatTandaTangan,
      }).subscribe(res => {
        localStorage.setItem("tanda-tangan", JSON.stringify(this.tandaTangan))
        localStorage.setItem("marketing-checked", this.isMarketingChecked ? "Y" : "N")

        this.router.navigate(['eform/foto-nasabah-sales'])
      })

    }
  }
}
